import { render, staticRenderFns } from "./register_result.vue?vue&type=template&id=fe0832ec&scoped=true&"
import script from "./register_result.vue?vue&type=script&lang=js&"
export * from "./register_result.vue?vue&type=script&lang=js&"
import style0 from "./register_result.vue?vue&type=style&index=0&id=fe0832ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0832ec",
  null
  
)

export default component.exports